import React from 'react';
import { formatarTelefone } from 'util/numberUtil';

export default ({ className, value, onChange }) => {
  return (
    <input
      type="text"
      className={`form-control ${className}`}
      value={value}
      onChange={(event) => {
        onChange(formatarTelefone(event.target.value));
      }}
    />
  );
};
